import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    if (window.fbq) return;
    const n: any = window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    window.fbq('init', '889901803806297');
    window.fbq('track', 'PageView');
  }, []);
  return <SalesPage data-id="element-0" />;
}